import { useLocation } from 'react-router-dom';

export default function HelpPage() {
    const location = useLocation();
    const isSidebarOpen = location?.state?.isSidebarOpen;

    return (
        <div className={`p-6 md:p-10 overflow-auto ${isSidebarOpen ? 'md:ml-64' : 'md:ml-0'}`}>
            <h1 className="text-3xl font-extrabold text-gray-900 dark:text-white">Help & Support</h1>
            <p className="mt-1 text-gray-500 dark:text-gray-400">Find answers to common questions.</p>
            <div className="mt-6 bg-white dark:bg-slate-800 rounded-lg shadow-lg p-6 space-y-6">
                <div>
                    <h3 className="font-bold text-lg text-gray-800 dark:text-gray-200">How do I know when my item is funded?</h3>
                    <p className="mt-1 text-gray-600 dark:text-gray-400">You will receive an email notification once your campaign is fully funded. The status on your dashboard will also change to "Funded".</p>
                </div>
                <div>
                    <h3 className="font-bold text-lg text-gray-800 dark:text-gray-200">How do I collect my item?</h3>
                    <p className="mt-1 text-gray-600 dark:text-gray-400">Once your item is funded, we will contact you via email with details about the collection center, date, and time. Remember to bring the original ID you used for verification.</p>
                </div>
                <div>
                    <h3 className="font-bold text-lg text-gray-800 dark:text-gray-200">Need more help?</h3>
                    <p className="mt-1 text-gray-600 dark:text-gray-400">For any other questions, please contact our support team at <a href="mailto:support@givetechtotheblind.com" className="text-orange-600 hover:underline">support@givetechtotheblind.com</a>.</p>
                </div>
            </div>
        </div>
    );
}